import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicModal, YesNoViewNew } from 'core/components';

function BaasicConfirmModalNewTemplate({ modalParams, className }) {
    return (
        <BaasicModal modalParams={modalParams} className={`modal__content modal--confirmation${className ? ` ${className}` : ''}`}>
            <YesNoViewNew
                question={modalParams.data.question}
                message={modalParams.data.message}
                onConfirm={modalParams.onConfirm}
                onCancel={modalParams.onCancel}
                loading={modalParams.loading}
                loadingMessage={modalParams.data.loadingMessage}
                yesLabel = {modalParams.yesLabel ? modalParams.yesLabel : 'MODAL.YES_NO_CONFIRM_LABEL'}
                noLabel = {modalParams.noLabel ? modalParams.noLabel : 'MODAL.YES_NO_CANCEL_LABEL'}
                swapButtons = {modalParams.swapButtons}
                doNotShowCancel = {modalParams.doNotShowCancel}
                compactMessage = {modalParams.compactMessage}
                iconClassName = {modalParams.iconClassName}
            />
        </BaasicModal>
    );
}

BaasicConfirmModalNewTemplate.propTypes = {
    modalParams: PropTypes.object,
    className: PropTypes.string
}

export default defaultTemplate(BaasicConfirmModalNewTemplate);
